import React, { useContext } from 'react';
import { useTheme } from '@emotion/react';
import { AgendaContext } from '../../../contexts/AgendaContext.jsx';
// Mui components
import { Typography, Box } from '@mui/material';
// Hooks
import { toCamelCaseAllWords } from '../../../utils/Hooks/textFormatted.js';

function DetailUserSolicitudes() {
  const theme = useTheme();

  const { solicitudDetail } = useContext(AgendaContext);

  return (
    solicitudDetail && (
      <Box
        sx={{
          backgroundColor: theme.palette.backgroundPrimary.main,
          height: '118px',
          width: '100%',
          padding: '1.5rem',
          borderRadius: '1rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem'
        }}>
        <Typography variant="h4">{toCamelCaseAllWords(solicitudDetail?.nombre)}</Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: '2.5rem'
          }}>
          <Typography variant="bodyM">
            Número de CUIT:{' '}
            <Typography
              component="span"
              style={{ fontFamily: 'NunitoSansBold', whiteSpace: 'nowrap' }}>
              {solicitudDetail?.cuit}
            </Typography>
          </Typography>
          <Typography variant="bodyM">
            N° de prestador:{' '}
            <Typography
              component="span"
              style={{ fontFamily: 'NunitoSansBold', whiteSpace: 'nowrap' }}>
              {solicitudDetail?.identificador}
            </Typography>
          </Typography>
        </Box>
      </Box>
    )
  );
}

export default DetailUserSolicitudes;
